import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const formatIsoLocalToDateTimeString = (value: string, dateFormat?: string): string => {
    if (value === '') {
        return '';
    }
    return dayjs(value).format(dateFormat || 'YYYY-MM-DD HH:mm');
};

export default formatIsoLocalToDateTimeString;
